import React from "react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { assets } from "../data/siteData";

export default function OnlineMonitoringPage() {
  return (
    <>
      <SEO
        title="Online Water Quality Monitoring System in Kolkata, West Bengal | IoT Water Monitoring"
        description="Hydrotec Solutions provides IoT-based online water quality monitoring systems for Kolkata, Newtown, Rajarhat, and West Bengal. Real-time dashboards for flow, pressure, quality, and alerts across water infrastructure."
        keywords="online water monitoring Kolkata, IoT water quality West Bengal, water monitoring system Newtown, real-time water monitoring Rajarhat, water quality sensor Kolkata, smart water monitoring West Bengal"
        canonical="https://hydroteclimited.com/solutions/online-monitoring"
      />
      <PageHero
        title="Online Water Monitoring"
        text="Connected monitoring systems for water quality, flow, pressure, tank levels, usage trends, and operational visibility."
        image={assets.dashboardPreview}
      />

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <h2 className="text-3xl font-bold text-slate-900">
              Real-time visibility for smarter water operations
            </h2>
            <p className="mt-5 leading-8 text-slate-600">
              Hydrotec online monitoring solutions enable connected oversight of
              water systems through dashboards, data logging, site comparison,
              live reporting, and performance analysis.
            </p>
            <p className="mt-4 leading-8 text-slate-600">
              Monitoring can be configured for parameters such as TDS, pH,
              pressure, flow, tank levels, dispensing records, alarms, and
              system status to improve operational efficiency and decision-making.
            </p>
          </div>

          <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-slate-900">Monitoring Capabilities</h3>
            <ul className="mt-5 space-y-3 text-slate-600">
              <li>• Live dashboard reporting</li>
              <li>• Water quality and system performance visibility</li>
              <li>• Site-wise and master-site comparison</li>
              <li>• Alert and trend-based monitoring</li>
              <li>• Data-driven maintenance planning</li>
              <li>• Integration with IoT devices and sensors</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}